// extracted by mini-css-extract-plugin
module.exports = {"thecomp":"ConnectHome_thecomp__qWH_a"};